<template>
	<div class="asd" >
		<el-form
          :label-position="labelPosition"
          label-width="85px"
          :model="formLabelAlign"
          :rules="rules"
			    ref="ruleForm"
          >
		  <el-form-item label="企业名称" width="100"  prop="name">
		    <el-input v-model="formLabelAlign.name"   placeholder="请输入企业名称" style="width: 40%"></el-input>
		  </el-form-item>

      <el-form-item label="福利发放人" width="100" prop="phone">
		    <el-input  v-model="formLabelAlign.phone"  placeholder="请输入福利发放人的手机号" style="width: 40%"></el-input>
		  </el-form-item>

      <el-form-item label="企业头像" width="100" class='upload'>
        <!-- <el-upload
          action="https://up-z1.qbox.me"
          class="avatar-uploader"
          :show-file-list="false"
          :on-change="LocalUrl"
          :on-success="handleAvatarSuccess"
          :auto-upload="false"
          ref="upload"
          :data="uploadToken"
          > 
          <img v-if="imageUrl" :src="imageUrl" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload> -->
        <ul class='imagesList'>
          <li class="imagesItem" v-for='(item, index) in imagesList' :key='index'>
            <img class='img' :src="item" alt width="100%" height='100%'/>
            <img class='del' src="../../assets/images/fail.png" alt="" @click='delImages(index)'>
          </li>
        </ul>
        <div v-show='!imagesList.length' @click="handleUploadImages(1)" class="picture">
          <img src="../../assets/images/addImages.png" alt width="100%" height='100%'/>
        </div>
		  </el-form-item>

     <el-form-item label="详细地址" width="100" prop="address">
		    <el-input  v-model="formLabelAlign.address"  placeholder="请输入详细地址" style="width: 70%" ></el-input>
		 </el-form-item>

     <el-form-item label="企业描述" width="100" prop="description">
		    <el-input  v-model="formLabelAlign.description" type="textarea" :maxlength="500" 
         :autosize="{ minRows: 5}"
         placeholder="请输入企业的详细描述（500字以内）" style="width: 70%;"></el-input>
		 </el-form-item>
		</el-form>

		<el-button  type="success" style="margin-left:78px;width: 150px;font-size:18px;"  @click="submitForm('ruleForm')">保 存</el-button>
	</div>
</template>

<script>
import { quillEditor } from "vue-quill-editor"; //调用编辑器
import {
  AddCompany,
  compile,
  UpdateCompany,
  getUploadToken,
  getUploadId
} from "../../api/companyApi/company";
import A from "../../assets/upload";
import { upLoad } from "../../api/companyApi/qiniu";
import { validateTel } from "@/utils/validate";
import axios from 'axios'
export default {
  name: "Add",
  mixins: [A],
  props: [""],
  data() {
    //验证
    const valiPhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("电话不能为空"));
      } else if (!validateTel(value)) {
        return callback(new Error("请输入正确手机号"));
      } else {
        callback();
      }
    };
    const valiName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("企业名称不能为空"));
      } else {
        callback();
      }
    };
    const description = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("企业描述不能为空"));
      } else {
        callback();
      }
    };
    const address = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("详细地址不能为空"));
      } else {
        callback();
      }
    };

    return {
      labelPosition: "left",
      imageUrl: "",
      imageUr2: "",
      imgType:false,
      uploadToken:{token:""},
      formLabelAlign: {
        name: "",
        type: "",
        phone: '',
        address: "",
        description: ""
      },
      imagesList: [],
      rules: {
        phone: [{ validator: valiPhone, trigger: "blur" }],
        name: [{ validator: valiName, trigger: "blur" }],
        description: [{ validator: description, trigger: "blur" }],
        address: [{ validator: address, trigger: "blur" }]
      }
    };
  },
   mounted() {
    this.$on('upload-finish', (data) => {
      let { isupdate } = data;
      // console.log(data);
      if(!data) return;
      if(this.imagesList.length > 1) {
        this.$message('最多上传1张图');
        return;
      }
      this.imagesList.push(data.src);
      // this.imagesList = this.order2(this.imagesList);
      
    });
  },
  methods: {
    LocalUrl(file,fileList) {
     // this.imgType= this.beforeAvatarUpload(file.raw);
      this.imageUrl = file.url;
    },
    handleAvatarSuccess(res, file) {
      this.$router.push({ name: "企业管理" });
    },
    handleUploadImages(index) {
      if(index == 1) {
        if (this.imagesList.length >= 5) {
          this.$message('最多上传5张图');
          return;
        }
      }
      let option = {
        multiple: !0,
        params: {
          isupdate: index,
          region: "ap-chongqing",
          bucket: "range-smartpark-1304188286",
          previewUrl: "https://cdn.shop.rangepark.cn"
        },
        getFileId: getUploadId,
        getAuthFunction: getUploadToken,
        accept: "image/*"
      };
      this.handleClickUpload(option);
    },
    //获取图片路径
    getImageSrc() {
      if (!this.imagesList.length) {
        this.$message('上传图片不能为空');
        return;
      } else {
        return this.imagesList;
      }
    },
    delImages(index) {
      this.imagesList.splice(index, 1);
      // console.log(this.imagesList);
    },
    //添加企业
     submitForm(formName){
      let _this = this;
      // if(!this.imgType){
      //   this.$message.error('企业头像必须是jpg格式且大小小于2m!');
      //   return;
      // }
      let companyId = this.$route.params.companyId;
      let name = this.formLabelAlign.name;
      let phone = this.formLabelAlign.phone;
      let description = this.formLabelAlign.description;
      let address = this.formLabelAlign.address;
      let logo = this.imagesList[0]

      this.$refs[formName].validate(valid => {
        if (valid) {
          if (companyId) {
            //修改企业的方法
            let that = this;
            UpdateCompany(companyId, name, phone,address, description,logo).then(function(res) {
              console.log(res.data)
              if (res.data.msg == "success") {
                that.$router.push({ name: "企业管理" });
                // return res.data.uploadToken;
              }
            }).catch(error => {
              let msg = "请求出错！";
              if (error.response.data) {
                msg = error.response.data.msg || "请求出错";
              }
              this.$message({
                type: "error",
                message: msg
              });
            });
          } else {
            let logo = this.imagesList[0];
            if(logo ==""){
              this.$message({
                type: "error",
                message:"请添加头像"
              });
            }else{
                //新增企业的方法
                console.log(logo)
                let that = this;
                AddCompany(name, phone, address, description,logo).then(function(res) {
                  console.log(res)
                  if(res.code == 1) {
                    that.$router.push({ name: "企业管理" });
                  }
                    // return res.data.uploadToken;
                })
                .catch(err => {
                    console.log(err)
                    this.$message({
                      type: "error",
                      message: err
                    });
                })
                  // .then(function(res) {
                  //   _this.upToQiniu(res);
                  // }) 
                  // .catch(error => {
                  //   var msg = "请求出错！";
                  //   if (error.response.data) {
                  //     msg = error.response.data.msg || "请求出错";
                  //   }
                  //   this.$message({
                  //     type: "error",
                  //     message: msg
                  //   });
                  // });
            }
          }
        } else {
          return false;
        }
      });
    },
    //  上传图片
    upToQiniu(res) {
      this.uploadToken.token=res;
      this.$refs.upload.submit();
    },
    //编辑企业
    getCompanyInfo(companyId) {
      let _this = this;
      if (companyId) {
        //企业数据回显
        compile(companyId).then(function(res) {
          console.log(res);
          _this.formLabelAlign.name = res.data.name;
          _this.formLabelAlign.address = res.data.address;
          _this.formLabelAlign.description = res.data.description;
          _this.formLabelAlign.phone = res.data.phone;
          _this.imagesList.push(res.data.logo);
        });
      }
    },

  },
  created() {
    let companyId = this.$route.params.companyId;
    this.getCompanyInfo(companyId);
  }
};
</script>

<style lang="scss" scoped>
.asd {
  background-color: white;
  height: 100%;
  text-align: left;
  padding-top: 30px;
  padding-left: 30px;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader {
  height: 102px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;

  border: 1px solid #e4e0e0;
  border-radius: 3px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader-icon:hover {
  border-color: #409eff;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
.upload{
  /deep/ .el-form-item__content{
    display: flex;
    .imagesList{
      display: flex;
      margin:0;
      padding-left:0;
      .imagesItem{
        list-style-type: none;
        padding-right: 20px;
        position: relative;
        .img{
          width: 85px;
          height: 85px;
          // border: 1px solid #f0f0f0;
        }
        .del{
          width:20px;
          height:20px;
          position: absolute;
          top:-10px;
          right:10px;
        }
      }
    }
    .picture {
      width: 85px;
      height: 85px;
      border: 1px solid #f0f0f0;
      padding:20px;
      box-sizing: border-box;
      img{
        width:100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/company/AddCompany.vue